import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LEAD_CONTACTS_MANAGEMENT, LEAD_CONTACTS_MANAGEMENT_NO_BG } from 'src/app/common/models/tableColumns';
import { environment } from 'src/environments/environment';
import { AdministrationService } from '../administration.service';
import { DatePipe } from '@angular/common';

import { Router } from '@angular/router';
import * as _ from 'lodash';

interface UPD {
  tfcLevel1: string;
  updId: string;
  updName: string;
}

@Component({
  selector: 'app-lead-contacts-management',
  templateUrl: './lead-contacts-management.component.html',
  styleUrls: ['./lead-contacts-management.component.scss']
})
export class LeadContactsManagementComponent implements OnInit {

  star = 'fa fa-fw fa-search';
  loading = true;
  loadingregionalcomplainceListMessage;
  exportDialog = false;
  filteredRows: any = [];
  selectedRows: any = [];
  responsedataMarket;
  Id;
  fastRegionName;
  model: any = {};
  modelEdit: any = {};
  userId: any;
  userDetails: any;
  enterRegionName = false;
  isRegionEmpty = false;
  isMarketEmpty = false;
  isLDEmpty = false;
  status = [];
  prevName: any;
  prevStatus: any;
  uploadDialog = false;
  uploadedFiles: any[] = [];
  progress: number;
  message: string;
  selectedUPDname: any;
  dropDownupd: UPD[];
  selectedUpd: UPD;
  filetype = '.xlsx';
  ddlFormulationCategory: any;
  ddlFormulationType: any;
  ddlFormulationClass: any;
  ddlFormulationSubClass: any;
  rcl2AddForm: FormGroup;
  rcl2EditForm: FormGroup = this.fb.group({
    regionName: ['', Validators.required],
    productType: ['', Validators.required],
    updName: ['', Validators.required],
    isActive: ['']
  });
  updNameData: any = [];
  tfcmappingSelection: any;
  editId: any;
  submitted = false;
  changeEditClass = false;
  isCategoryHasData = 1;
  featureFragranceFlag: any;
  isSubClassCrossButtonClicked = false;
  buttonSelection = false;
  divisionData: any;
  filteredDataDivision = [];
  division: any;
  selectedFC = '';
  divisionId: any;
  filteredDataFC = [];
  selectedType = '';
  filteredDataType = [];
  filteredDataClass = [];
  selectedClass = '';
  filteredDataSubClass = [];
  selectedSubClass = '';
  selectedDivision = '';
  isUpdChangedInEditForm = false;
  leadContactsListColumns;
  leadContactsListData: any;
  addregionalComplains = false;
  editregionalComplains = false;
  addregionalComplainsSearch = false;
  listTypeToDD = [];
  selectedTypes = [];
 isSuperAdmin: any;
  openPopUp = false;
  contactName = '';
  contactEmail = '';
  isEmailValid = false;
  selectedListType: any;
  selectedStatus: any;
  selectedBusinessGroup: any;
  disableSubmit = true;
  listTypeOptions = null;
  popupHeaderValue: string;
  editRowId: any;
  selectedMasterListType: any;
  disableBGSelection = false;
  disableStatusSelection = false;

  constructor(
    private apiService: AdministrationService,
    public matSnackBar: MatSnackBar,
    private http: HttpClient,
    public fb: FormBuilder,
    public router: Router,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {
    this.getListTypes();
    this.resetAddPopUpValues();
    this.updDropDown();
    this.selectedStatus = '1';
    this.leadContactsListColumns = LEAD_CONTACTS_MANAGEMENT;
    this.userDetails = JSON.parse(localStorage.getItem('userRolesPermissions'));
    this.userDetails.roles.forEach(c => {
          if (c.roleId === 150) {
            this.isSuperAdmin = true;
          }
        });

    if (this.userDetails != null) {
      if (this.isSuperAdmin === 'false' || this.userDetails.roles.filter(r => r.roleId === 150).length <= 0) {
        this.loading = false;
        this.router.navigate(['/home']);
      }
    }
    if (this.userDetails != null) {
      this.userId = this.userDetails.userId;
    }
    this.addParentProperties();
  }
  updDropDown() {
    const apiurl = environment.APIFAsT + '/getsubstancesearchupds';
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.dropDownupd = response1;
    });
  }

  getRegionalComplainceList(selectedTypes) {
    if (selectedTypes.groupId === '2') {
      // For SIR do not display BG column
      this.leadContactsListColumns = LEAD_CONTACTS_MANAGEMENT_NO_BG;
    } else {
      this.leadContactsListColumns = LEAD_CONTACTS_MANAGEMENT;
    }
    this.loadingregionalcomplainceListMessage = 'Getting Contacts Details';
    this.loading = true;
    const apiurl = environment.APIFAsT + '/getLeadContactsManagement';
    const apiBody = {
      id: null,
      groupTypeId: selectedTypes.groupId,
      name: null,
      email: null,
      active: null,
      divisionId: null,
      submittedBy: null,
      submittedDate: null,
      updatedBy: null,
      updatedDate: null
    };
    this.apiService.postComponentMasterData(apiurl, apiBody).subscribe((response1) => {
      this.loading = false;
      if (response1.length !== 0) {
        this.leadContactsListData = response1.map(respElem => {
          return {
            id: respElem.id,
            groupTypeId: respElem.groupTypeId,
            name: respElem.name,
            email: respElem.email,
            active: respElem.active,
            divisionId: respElem.divisionId,
            submittedBy: respElem.submittedBy,
            submittedDate: respElem.submittedDate ? this.datePipe.transform(new Date(respElem.submittedDate), 'dd-MM-yyyy') : '',
            updatedBy: respElem.updatedBy,
            updatedDate: respElem.updatedDate ? this.datePipe.transform(new Date(respElem.updatedDate), 'dd-MM-yyyy') : '',
          };
        });
      } else {
        this.leadContactsListData = [];
      }
    }, (error) => {
      this.loading = false;
    });
  }

  addParentProperties() {
    this.loading = true;
    // this.loadingMsg = 'Fetching CUC Properties';
    const apiurl = environment.APIFAsT + '/leadgroupmaster';
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.loading = false;
      this.listTypeToDD = response1;
    }, (error) => {
      this.loading = false;
    });
  }


  addLeadContacts() {
    this.openPopUp = true;
    this.popupHeaderValue = 'Add Contact';
    this.disableStatusSelection = true;
  }

  resetAddPopUpValues() {
    this.openPopUp = false;
    this.contactName = '';
    this.contactEmail = '';
    this.selectedListType = null;
    this.selectedStatus = '1';
    this.selectedBusinessGroup = null;
    this.disableBGSelection = false;
    this.disableStatusSelection = false;
    this.enableOrDisableSubmit();
  }
  submitPopUpValues() {
    if (this.popupHeaderValue === 'Add Contact') {
      this.addPopupValues();
    } else {
      this.editPopupValues();
    }
  }

  checkForDuplicateAndThenAddOrEditRecord(EditOrAddApiUrl, EditOrAddApiBody) {
    this.selectedMasterListType = this.getMasterSelection();

    // Get List of contacts based on list type being added/Edited
    const selectedTypes = { groupId: this.selectedListType };
    if (selectedTypes.groupId === '2') {
      // For SIR do not display BG column
      this.leadContactsListColumns = LEAD_CONTACTS_MANAGEMENT_NO_BG;
    } else {
      this.leadContactsListColumns = LEAD_CONTACTS_MANAGEMENT;
    }
    const apiurl = environment.APIFAsT + '/getLeadContactsManagement';
    const apiBody = {
      id: null, groupTypeId: selectedTypes.groupId, name: null, email: null, active: null,
      divisionId: null, submittedBy: null, submittedDate: null, updatedBy: null, updatedDate: null
    };
    this.apiService.postComponentMasterData(apiurl, apiBody).subscribe((response1) => {
      this.loading = false;
      if (response1.length !== 0) {
        this.leadContactsListData = response1.map(respElem => {
          return {
            id: respElem.id, groupTypeId: respElem.groupTypeId, name: respElem.name, email: respElem.email,
            active: respElem.active, divisionId: respElem.divisionId, submittedBy: respElem.submittedBy,
            submittedDate: respElem.submittedDate ? this.datePipe.transform(new Date(respElem.submittedDate), 'dd-MM-yyyy') : '',
            updatedBy: respElem.updatedBy,
            updatedDate: respElem.updatedDate ? this.datePipe.transform(new Date(respElem.updatedDate), 'dd-MM-yyyy') : '',
          };
        });
      } else {
        this.leadContactsListData = [];
      }

      // if Duplicate record then show error Else Call API
      const isDuplicateExists = this.checkForDuplicate();
      if (isDuplicateExists) {
        this.loading = false;
        this.openPopUp = false;
        this.disableBGSelection = false;
        this.matSnackBar.open('The Email ID you are trying to add already exists', 'close', {
          duration: 5000,
          panelClass: ['error']
        });
      } else {
        this.loading = true;
        this.callAddOrEditAPI(EditOrAddApiUrl, EditOrAddApiBody);
      }
    }, (error) => {
      this.loading = false;
    });
  }

  checkForDuplicate() {
    if (this.popupHeaderValue === 'Add Contact') {
      for (let i = 0; i < this.leadContactsListData.length; i++) {
        const element = this.leadContactsListData[i];
        if (this.contactEmail === element.email) {
          if (this.disableBGSelection) {
            // If notify SIR then directly return true else check for BG
            return true;
          } else {
            const bgId = this.getBussinessGrpId(element.divisionId);
            if (this.selectedBusinessGroup === bgId) {
              return true;
            }
          }
        }
      }
    } else {
      for (let i = 0; i < this.leadContactsListData.length; i++) {
        const element = this.leadContactsListData[i];
        if (element.id !== this.editRowId) {
          if (this.contactEmail === element.email) {
            if (this.disableBGSelection) {
              // If notify SIR then directly return true else check for BG
              return true;
            } else {
              const bgId = this.getBussinessGrpId(element.divisionId);
              if (this.selectedBusinessGroup === bgId) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  }

  callAddOrEditAPI(apiurl, apiBody) {
    this.apiService.postData(apiurl, apiBody).subscribe((response) => {
      this.loading = false;
      this.selectedMasterListType = this.getMasterSelection();
      this.getRegionalComplainceList({ groupId: this.selectedListType });
      this.openPopUp = false;
      this.disableBGSelection = false;
      const msg = this.popupHeaderValue === 'Add Contact' ? 'Successfully Added.' : 'Successfully Updated.';
      this.matSnackBar.open(msg, 'close', {
        duration: 3000,
        panelClass: ['success']
      });
    }, (error) => {
      this.loading = false;
      this.matSnackBar.open(error.error.message, 'close', {
        duration: 3000,
        panelClass: ['error']
      });
    });
  }

  addPopupValues() {
    this.loading = true;
    const userDetails = JSON.parse(localStorage.getItem('userRolesPermissions'));
    this.loadingregionalcomplainceListMessage = 'Adding Contact';
    const apiurl = environment.APIFAsT + '/addLeadContactsManagement';
    const apiBody = {
      groupTypeId: this.selectedListType,
      name: this.contactName.trim(),
      email: this.contactEmail.trim(),
      active: this.selectedStatus,
      divisionId: this.selectedBusinessGroup === 'null' ? '0' : this.selectedBusinessGroup,
      submittedBy: userDetails.userId,
      submittedDate: new Date(),
      updatedBy: null,
      updatedDate: null
    };
    this.checkForDuplicateAndThenAddOrEditRecord(apiurl, apiBody);
  }
  editPopupValues() {
    this.loading = true;
    const userDetails = JSON.parse(localStorage.getItem('userRolesPermissions'));
    this.loadingregionalcomplainceListMessage = 'Editing Contact';
    const apiurl = environment.APIFAsT + '/updateleadcontacts';
    const apiBody = {
      id: this.editRowId,
      groupTypeId: this.selectedListType,
      name: this.contactName.trim(),
      email: this.contactEmail.trim(),
      active: this.selectedStatus,
      divisionId: this.selectedBusinessGroup === 'null' ? '0' : this.selectedBusinessGroup,
      submittedBy: null,
      submittedDate: null,
      updatedBy: userDetails.userId,
      updatedDate: null
    };
    this.checkForDuplicateAndThenAddOrEditRecord(apiurl, apiBody);
  }
  enableOrDisableSubmit() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.isEmailValid = this.contactEmail ? emailRegex.test(this.contactEmail.trim()) : false;
    if (this.selectedListType !== '2') {
      if (this.contactName.trim() && this.contactEmail.trim() && this.isEmailValid && this.selectedListType && this.selectedStatus && this.selectedBusinessGroup && this.selectedListType !== 'null' && this.selectedBusinessGroup !== 'null') {
        this.disableSubmit = false;
      } else {
        this.disableSubmit = true;
      }
    } else {
      if (this.contactName.trim() && this.contactEmail.trim() && this.isEmailValid && this.selectedListType && this.selectedStatus && this.selectedListType !== 'null') {
        this.disableSubmit = false;
      } else {
        this.disableSubmit = true;
      }
    }
  }

  getListTypes() {
    const apiurl = environment.APIFAsT + '/leadgroupmaster';
    this.apiService.getData(apiurl).subscribe((response) => {
      this.loading = false;
      this.listTypeOptions = response;
    }, (error) => {
      this.loading = false;
      this.matSnackBar.open(error.error.message, 'close', {
        duration: 3000,
        panelClass: ['error']
      });
    });
  }

  onFilter(event) {
    if (event.filters != null) {
      this.filteredRows = (Object.keys(event.filters).length === 0 ? [] : event.filteredValue);
    }
  }

  selectRow(row) {
    if (row._selection === null || row._selection === undefined) {
      this.buttonSelection = false;
    } else {
      this.buttonSelection = true;
    }
  }

  editLeadContacts(tableData) {
    this.popupHeaderValue = 'Edit Contact';
    const rowData = tableData._selection;
    this.editRowId = rowData.id;
    this.contactName = rowData.name;
    this.contactEmail = rowData.email;
    this.selectedListType = this.getListTypeId(rowData.groupTypeId);
    this.selectedStatus = rowData.active === 'Active' ? '1' : '0';
    this.selectedBusinessGroup = this.getBussinessGrpId(rowData.divisionId);
    this.disableBG();
    this.disableStatusSelection = false;
    this.openPopUp = true;
    this.enableOrDisableSubmit();
  }
  getListTypeId(listType) {
    for (let i = 0; i < this.listTypeOptions.length; i++) {
      const element = this.listTypeOptions[i];
      if (listType === element.groupName) {
        return element.groupId;
      }
    }
    return undefined;
  }

  getBussinessGrpId(bg: string): string | undefined {
  for (let i = 0; i < this.dropDownupd.length; i++) {
    const element = this.dropDownupd[i];
    if (bg === element.updName) {
      return element.updId;
    }
  }
  return undefined;
}

  getMasterSelection() {
    const selectedGrp = {
      id: '',
      groupId: '',
      groupName: ''
    };
    this.listTypeToDD.forEach(grp => {
      if (grp.groupId === this.selectedListType) {
        selectedGrp.id = grp.id;
        selectedGrp.groupId = grp.groupId;
        selectedGrp.groupName = grp.groupName;
        return selectedGrp;
      }
    });
    return selectedGrp;
  }
  disableBG() {
    if (this.selectedListType === '2') {
      this.selectedBusinessGroup = 'null';
      this.disableBGSelection = true;
    } else {
      this.disableBGSelection = false;
    }
  }
}
